<template>
  <div
    ref="cartWrapper"
    class="cart-wrapper"
    v-if="$store.state.showCart"
  >
    <div class="cart">
      <OnClickOutside :do="() => $store.commit('toggleCart')">
        <div class="overflow-y-auto max-h-screen">
          <cart-product-list
            :supplyOrders="supplyOrders"
            :removeProduct="removeProduct"
            :deleteSupplyOrder="deleteSupplyOrder"
          ></cart-product-list>
        </div>
      </OnClickOutside>
    </div>
  </div>
</template>

<script>
import CartProductList from "./CartProductList.vue";
import useCartProducts from "../../composition/useCartProducts.js";
import OnClickOutside from "../OnClickOutside.vue";
import { onMounted, watch, ref, reactive } from "@vue/composition-api";
export default {
  components: {
    CartProductList,
    OnClickOutside
  },
  setup(_, ctx) {
    onMounted(() => {
      document.body.style.overflowY = "auto";
    });
    return useCartProducts(ctx);
  }
};
</script>

<style scoped>
.cart-wrapper {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  height: 100vh;
  background-color: rgba(18, 40, 58, 0.5);
  z-index: 1000;
}
.cart {
  position: absolute;
  right: 0;
  top: 0;
  opacity: 1;
  width: 500px;
  height: 100vh;
  background: white;
}
</style>


// WEBPACK FOOTER //
// Cart.vue?09d4c2c2